import React, { useState, useEffect } from 'react';
import { loadCredits, requestCredits } from '../../services/api';
import './SubscriptionStatus.css';

const SubscriptionStatus = () => {
  const [credits, setCredits] = useState(0);
  const [loading, setLoading] = useState(true);
  const [requesting, setRequesting] = useState(false);
  const [message, setMessage] = useState('');
  const [showRequestForm, setShowRequestForm] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        setLoading(true);
        const data = await loadCredits();
        setCredits(data.credits);
      } catch (error) {
        console.error('Error loading credits:', error);
        setMessage('Failed to load credits');
      } finally {
        setLoading(false);
      }
    };

    fetchCredits();
  }, []);

  const handleRequestCredits = () => {
    setShowRequestForm(true);
  };

  const handleSubmitRequest = async (e) => {
    e.preventDefault();
    if (!feedbackMessage.trim()) return;

    try {
      setRequesting(true);
      setMessage('');
      await requestCredits(feedbackMessage.trim());
      setMessage('Credits requested successfully! Admin will review your request.');
      setShowRequestForm(false);
      setFeedbackMessage('');
    } catch (error) {
      console.error('Error requesting credits:', error);
      setMessage(error.response?.data?.detail || 'Failed to request credits');
    } finally {
      setRequesting(false);
    }
  };

  const handleCancelRequest = () => {
    setShowRequestForm(false);
    setFeedbackMessage('');
  };

  if (loading) {
    return (
      <div className="subscription-status-card">
        <h3 className="card-title">Subscription Status</h3>
        <div className="loading-state">Loading...</div>
      </div>
    );
  }

  return (
    <div className="subscription-status component-card">
      <h2>Subscription Status</h2>
      
      <div className="subscription-info">
        <div className="info-item">
          <label>Credits remaining:</label>
          <div className="credits-section">
            <span className="credits-amount">{credits}</span>
            {!showRequestForm && (
              <button 
                className="refill-button"
                onClick={handleRequestCredits}
                disabled={requesting}
              >
                {requesting ? 'Requesting...' : 'Refill Credits'}
              </button>
            )}
          </div>
        </div>
      </div>
      
      {showRequestForm && (
        <div className="credit-request-form">
          <h3>Request Credits</h3>
          <form onSubmit={handleSubmitRequest}>
            <div className="form-group">
              <label htmlFor="feedback">Please provide feedback or reason for requesting credits:</label>
              <textarea
                id="feedback"
                value={feedbackMessage}
                onChange={(e) => setFeedbackMessage(e.target.value)}
                placeholder="Give us some feedback or reason for requesting credits..."
                rows={4}
                required
                disabled={requesting}
              />
            </div>
            <div className="form-actions">
              <button 
                type="button" 
                className="cancel-button" 
                onClick={handleCancelRequest}
                disabled={requesting}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-button"
                disabled={requesting || !feedbackMessage.trim()}
              >
                {requesting ? 'Requesting...' : 'Request Credits'}
              </button>
            </div>
          </form>
        </div>
      )}
      
      <div className="credits-note">
        Each newsletter generation in playground consumes 1 credit
      </div>
      
      {message && (
        <div className={`message ${message.includes('successfully') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
    </div>
  );
};

export default SubscriptionStatus;
